export default {
  data() {
    return {
      validationRules: {
        email: [
          v => !!v || 'Email is required',
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,63})+$/.test(v) || 'Email must be valid'
        ],
        phone: [
          v => !!v || 'Phone Number is required',
          v => /^[0-9]{10}$/.test(v) || 'Phone Number must be valid'
        ]
      }
    };
  }
};
